import React from "react";

export const Address = ({ Icon, info1, info2 }) => {
  return (
    <li className="flex items-center justify-start gap-2 sm:gap-4 text-secondary text-f12 py-3 border-b border-Slate test">
      <Icon />
      <div className="flex flex-col text-left">
        <span>{info1}</span>{" "}
        <span className="text-primary text-f14">{info2}</span>
      </div>
    </li>
  );
};
